import React, { useState, useCallback, useRef } from 'react';

import { Breadcrumb, PageHeader, Button } from 'antd';
import styles from './index.module.css';
import globalStyles from '../common.module.css';
import ConflictForm from '../../forms/conflictForm'
import Auth from '../../Auth';
import { navigate } from '@reach/router';
import { useConflict, useConflictState } from '../../context/conflict/index';
import { ConflictRequestFactory } from '../../shared/requestFactory';
import { useRequest } from '../../shared/hooks';

function EditConflict() {
  const { requestMaker } = useRequest(); // Custom Hook
  const auth = new Auth();
  const currentUser = auth.currentUser();  
  let {
    updateConflict
  } = useConflict();
  let { selectedConflict} = useConflictState();

  return (
    <React.Fragment>
      <Breadcrumb style={{ margin: '16px 0' }}>
        <Breadcrumb.Item onClick={() => {
          navigate('/')
        }}>Home</Breadcrumb.Item>
        <Breadcrumb.Item>Edit Conflict</Breadcrumb.Item>
      </Breadcrumb>
      <div className={globalStyles.container}>
      <PageHeader
      
      style={{borderBottom: '1px solid #ddd', marginBottom: '20px'}}
      onBack={() => navigate(-1)}
      title="Edit Conflict"
    ></PageHeader>
        <ConflictForm mode="Edit" data={selectedConflict} onSubmit={(data) => {
          updateConflict(data);
          navigate('/');
        }} />
      </div>
    </React.Fragment>
  );
}

export default EditConflict;
